import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import PatientModel from "../../models/patient";
import { BootstrapTable , TableHeaderColumn  } from 'react-bootstrap-table';
import { Link } from "react-router-dom";

import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import  PanelLayout  from "../layout/panel-layout";

const rightAlignStyle = {
   
    textAlign: 'right'
  };

  class CustomSearchField extends React.Component {
    // It's necessary to implement getValue
    getValue() {
      return ReactDOM.findDOMNode(this).value;
    }
  
    // It's necessary to implement setValue
    setValue(value) {
      ReactDOM.findDOMNode(this).value = value;
    }
  
    render() {
      return (
        <input
          className={ `form-control` }
          type='text'
          defaultValue={ '' }
          placeholder={ 'جستجو' }
          onKeyUp={ this.props.search }/>
      );
    }
  }
  function buttonFormatter(cell, row,extra) {
    return (
      <div>
       {/*   <Link to={`/patientcertrequest/show/${cell}`} className="btn btn-primary btn-sm"><i className="fa fa-list"></i> لیست گواهی</Link> 
       */}
        
        
          <Link to={`/pp/${cell}`} className="btn btn-success btn-sm"><i className="fa fa-pencil"></i>  ویرایش </Link>
          &nbsp;
          <button className="btn btn-warning btn-sm" onClick={()=>extra.props.deleteHandler(cell)}><i className="fa fa-trash"></i> حذف </button>
          &nbsp;
          <Link to={`/patientcertrequest/show/${cell}`} className="btn btn-primary btn-sm"><i className="fa fa-list"></i> لیست گواهی</Link> 
         
      </div>
    );
  }
  function cityFormatter(cell, row) {
    return cell!=null ? cell.Title:'';
  }
    


class PatientList extends React.Component {
    
    constructor(props) {
        super(props);
       
        this.state = {
        
          sizePerPage: 10,
          currentPage: 1,
          sortField :'datecreated',
          sortOrder:'desc',
          searchText:''
        };

        this.onPageChange=this.onPageChange.bind(this);
        this.onSizePerPageList=this.onSizePerPageList.bind(this);
        this.onSortChange=this.onSortChange.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
      }
    
      onPageChange(page, sizePerPage) {
        const {sortField,sortOrder,searchText} = this.state;
        this.props.remoteDataHandler(page,sizePerPage,sortField,sortOrder,searchText);
        this.setState({
        
          currentPage: page,
          sizePerPage: sizePerPage
        });
      }
    
      onSizePerPageList(sizePerPage) {
        const {currentPage}  =this.state;
        const {sortField,sortOrder,searchText} = this.state;
       
        this.props.remoteDataHandler(currentPage,sizePerPage,sortField,sortOrder,searchText);
        this.setState({
          
          sizePerPage: sizePerPage
        });
      }
      onSortChange(sortName, sortOrder) {
        console.log(sortOrder);
        const {currentPage,sizePerPage,searchText}=this.state;
        this.props.remoteDataHandler(currentPage,sizePerPage,sortName,sortOrder,searchText);


    
        this.setState({
            sortField: sortName,
            sortOrder: sortOrder
        });
      }

      onSearchChange(searchText, colInfos, multiColumnSearch) {
        const {currentPage,sizePerPage,sortField,sortOrder}=this.state;
       

        const text = searchText.trim();
        if (text === '') {
          this.props.remoteDataHandler(currentPage,sizePerPage,sortField,sortOrder,'');  
          this.setState({
            searchText: searchText
          });
          return;
        }else{
            
            this.props.remoteDataHandler(1,sizePerPage,sortField,sortOrder,searchText);  
            this.setState({
              searchText: searchText
            });
            return; 
        }
    
      }
      
    

    

    render() { 
      const {list}=this.props;
      console.log('TABLE',list)
        return ( 
            <div>
                <PanelLayout title={"لیست مراجعین"}>
                
                    <div className="panel-body custom">
                      {/* 
                        <div className="panel panel-default">
                            <div className="toolbox">

                                <Link to="/patient" className="btn btn-primary btn-sm" onClick={this.handleClick} ><i className="fa fa-user"></i>  مراجع جدید </Link>

                            </div>
                        </div>
                       */}
                            <BootstrapTable data={list && list.Queryable}  striped hover
                                headerContainerClass='rightAlignStyle'
                                bodyContainerClass='rightAlignStyle'
                                remote={ true } pagination={ true } search={ true }
                                fetchInfo={ { dataTotalSize: (list!=null? list.RowCount:0) } }
                                options={ { sizePerPage: this.state.sizePerPage,
                                    onPageChange: this.onPageChange,
                                    sizePerPageList: [ 5, 10,20,30,50 ],
                                    page: (list!=null? list.CurrentPage:1),
                                    onSizePerPageList: this.onSizePerPageList,
                                    onSortChange: this.onSortChange,
                                    onSearchChange: this.onSearchChange,
                                searchField: (props) => (<CustomSearchField { ...props }  />)
                                 } }   
                            >
                                <TableHeaderColumn isKey dataField='Id' hidden >id</TableHeaderColumn>
                                <TableHeaderColumn dataField='NationalCode' thStyle={{textAlign:"right",width:120}} tdStyle={{textAlign:"right",width:120}}>کد ملی</TableHeaderColumn>
                                <TableHeaderColumn dataField='FirstName' dataSort={ true } thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}}>نام</TableHeaderColumn>
                                <TableHeaderColumn dataField='LastName' dataSort={ true } thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}}>نام خانوادگی</TableHeaderColumn>
                                <TableHeaderColumn dataField='FatherName' dataSort={ true } thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}}>نام پدر</TableHeaderColumn>
                                <TableHeaderColumn dataField='IdentityCode' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}}>شماره شناسنامه</TableHeaderColumn>
                                <TableHeaderColumn dataField='IdentityCityName' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}}>محل صدور</TableHeaderColumn>
                                <TableHeaderColumn dataField='Id' thStyle={{textAlign:"right", width:260}} tdStyle={{textAlign:"right", width:260}} dataFormat={ buttonFormatter } formatExtraData={this}></TableHeaderColumn>
                            </BootstrapTable>

                        
                    </div>    
                   
                </PanelLayout>
               
                
                
            </div>
        
        );
    }
}

 
export default PatientList;